import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  Switch, FormControlLabel, Grid, Button, Typography, FormControl,
  Select, Input, MenuItem, Paper
} from '@material-ui/core'

import { withStyles, makeStyles } from '@material-ui/core/styles'

import { updateOrgSettings } from '../../../../redux/actions'
import { NotificationToast } from '../../tools/Toast'
import { handleTextPrepper } from '../../../../utils'

const StyledSwitch = withStyles({
  switchBase: {
    color: 'white',
    '&$checked': {
      color: '#A4D164'
    },
    '&$checked + $track': {
      backgroundColor: '#A4D164'
    }
  },
  checked: {},
  track: {}
})(Switch)

const useStyles = makeStyles((theme) => ({
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  switchLabel: {
    color: '#0000008A',
    fontWeight: 'bold'
  },
  underline: {
    '&&&&:hover:before': {
      borderBottomColor: '#8AB651'
    },
    '&:after': {
      borderBottomColor: '#A4D164'
    }
  },
  controlPaper: {
    padding: theme.spacing(1.5, 0),
    width: '100%'
  }
}))

const useSelectStyles = makeStyles((theme) => ({
  select: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    padding: theme.spacing(1.5, 2),
    border: '1px solid rgba(0, 0, 0, 0.26)',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    transition: 'background-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
    '&:focus': {
      backgroundColor: '#f5f5f5',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px'
    },
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  }
}))

/* Material switch components from https://material-ui.com/components/switches/  */

/**
 * Returns organization settings forms
 */
const OrganizationSettings = ({ onSubmit }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const selectClasses = useSelectStyles()

  const settings = useSelector(state => state.orgSettingsSettings.general)
  const aupsList = useSelector(state => state.aups.aupList)

  const settingsForm = {
    defaultAUP: settings.defaultAUP,
    aupName: settings.aupName,
    authenticationMethod: settings.authenticationMethod,
    disableAgents: settings.disableAgents,
    enableWebLog: settings.enableWebLog,
    enableSMS: settings.enableSMS,
    enableLSAlerts: settings.enableLSAlerts
  }

  const [aups] = useState(aupsList)
  const [form, setForm] = useState(settingsForm)

  //  NOTE: put back if auto-update toggle is kept, remove if deleted
  // const [autoUpdate, setAutoUpdate] = useState(true)

  const onChange = (prop) => e => {
    setForm({ ...form, [prop]: e.target.value })
  }

  const submitForm = async () => {
    const settings = Object.assign({}, form)
    settings.disableAgents = settings.disableAgents ? 1 : 0
    settings.enableWebLog = settings.enableWebLog ? 1 : 0
    settings.defaultAUP = handleTextPrepper(settings.defaultAUP)
    settings.aupName = handleTextPrepper(settings.aupName)
    settings.enableSMS = settings.enableSMS ? 1 : 0
    settings.enableLSAlerts = settings.enableLSAlerts ? 1 : 0
    dispatch(updateOrgSettings(settings))
    NotificationToast(false, 'Settings updated successfully!')
  }

  // const toggleDisableAgents = () => {
  //   const newForm = { ...form }
  //   newForm.disableAgents = !newForm.disableAgents
  //   setForm(newForm)
  // }

  const toggleWebLogging = () => {
    const newForm = { ...form }
    newForm.enableWebLog = !newForm.enableWebLog
    setForm(newForm)
  }

  const toggleSMS = () => {
    const newForm = { ...form }
    newForm.enableSMS = !newForm.enableSMS
    setForm(newForm)
  }

  const toggleLSAlerts = () => {
    const newForm = { ...form }
    newForm.enableLSAlerts = !newForm.enableLSAlerts
    setForm(newForm)
  }

  //  NOTE: put back if auto-update toggle is kept, remove if deleted
  // const toggleAutoUpdate = () => {
  //   setAutoUpdate(!autoUpdate)
  // }

  const authOptions = ['username/password']

  return (
    <>
      <Grid container direction='row'>
        <Grid container item direction='column' spacing={2} className='m-auto h-100 w-100'>

          <Grid container item direction='row' justify='space-between' className='mb-4'>
            <Grid item>
              <h2>Advanced Settings</h2>
            </Grid>

            <Grid item>
              <Button
                variant='contained'
                className={classes.blueBtn}
                onClick={() => submitForm()}
              >
                Save
              </Button>
            </Grid>
          </Grid>

          <Grid container item direction='row'>
            <Paper elevation={2} className={classes.controlPaper}>
              <Grid container direction='column' spacing={2} className='m-auto h-100 w-100'>
                {/* Commenting out Auto-Update toggle temporarily until confirmed if it should be removed.  */}
                <Grid container item direction='row' justify='space-between'>
                  {/* <Grid item xs={4} container direction='column'>

                    <Grid item container direction='row' justify='center'>
                      <Typography
                        variant='body1'
                        component='label'
                        className={classes.switchLabel}
                      >
                        Auto-Update Agent
                      </Typography>
                    </Grid>

                    <Grid item container direction='row' justify='center'>
                      <FormControlLabel
                        control={
                          <StyledSwitch
                            checked={autoUpdate}
                            onClick={toggleAutoUpdate}
                            className='ml-4'
                          />
                        }
                        label={autoUpdate ? <span>Enabled</span> : <span>Disabled</span>}
                      />
                    </Grid>

                  </Grid> */}

                  <Grid item xs={4} container direction='column'>

                    <Grid item container direction='row' justify='center'>
                      <Typography
                        variant='body1'
                        component='label'
                        className={classes.switchLabel}
                      >
                        Enable Web Logging
                      </Typography>
                    </Grid>

                    <Grid item container direction='row' justify='center'>
                      <FormControlLabel
                        control={
                          <StyledSwitch
                            checked={!!form.enableWebLog}
                            onChange={toggleWebLogging}
                            className='ml-4'
                          />
                        }
                        label={form.enableWebLog ? <span>Enabled</span> : <span>Disabled</span>}
                      />
                    </Grid>

                  </Grid>

                  <Grid item xs={4} container direction='column'>

                    <Grid item container direction='row' justify='center'>
                      <Typography
                        variant='body1'
                        component='label'
                        className={classes.switchLabel}
                      >
                        Enable Org SMS
                      </Typography>
                    </Grid>

                    <Grid item container direction='row' justify='center'>
                      <FormControlLabel
                        control={
                          <StyledSwitch
                            checked={!!form.enableSMS}
                            onClick={toggleSMS}
                            className='ml-4'
                          />
                        }
                        label={form.enableSMS ? <span>Enabled</span> : <span>Disabled</span>}
                      />
                    </Grid>

                  </Grid>
                  <Grid item xs={4} container direction='column'>
                    <Grid item container direction='row' justify='center'>
                      <Typography
                        variant='body1'
                        component='label'
                        className={classes.switchLabel}
                      >
                        Enable Learnsafe Preferred Alerts
                      </Typography>
                    </Grid>

                    <Grid item container direction='row' justify='center'>
                      <FormControlLabel
                        control={
                          <StyledSwitch
                            checked={!!form.enableLSAlerts}
                            onClick={toggleLSAlerts}
                            className='ml-4'
                          />
                        }
                        label={form.enableLSAlerts ? <span>Enabled</span> : <span>Disabled</span>}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container item direction='row' justify='center'>
                  {/* Temporarily disabling this functionality. If put back in, this grid block also should contain the enable alerts block above. */}
                  {/* <Grid item xs={5} container direction='column'>
                    <Grid item container justify='center' direction='row'>
                      <Typography
                        variant='body1'
                        component='label'
                        className={classes.switchLabel}
                      >
                        Temporarily Disable All Agents
                      </Typography>
                    </Grid>

                    <Grid item container justify='center' direction='row'>
                      <FormControlLabel
                        control={
                          <StyledSwitch
                            checked={!!form.disableAgents}
                            onChange={toggleDisableAgents}
                            className='ml-4'
                          />
                        }
                        label={form.disableAgents ? <span>Enabled</span> : <span>Disabled</span>}
                      />
                    </Grid>
                  </Grid> */}
                </Grid>

                <Grid container item direction='row' justify='center'>
                  <Grid item xs={10} container direction='row' alignItems='center' spacing={2} className='mx-auto w-100'>
                    <Grid item xs={4} className='pl-0'>
                      <Typography variant='h6'>
                        Default AUP:
                      </Typography>
                    </Grid>

                    <Grid item xs={8} className='pr-0'>
                      <FormControl fullWidth>
                        <Select
                          value={form.defaultAUP}
                          placeholder='Select an AUP'
                          onChange={onChange('defaultAUP')}
                          variant='filled'
                          input={<Input classes={{ underline: classes.underline }} />}
                          classes={selectClasses}
                        >
                          {
                            aups.map((aup) => (
                              <MenuItem key={`aup-${aup.aupID}`} value={aup.aupID}>
                                {aup.aupName}
                              </MenuItem>
                            ))
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container item direction='row' justify='center'>
                  <Grid item xs={10} container direction='row' alignItems='center' spacing={2} className='mx-auto w-100'>
                    <Grid item xs={4} className='pl-0'>
                      <Typography variant='h6'>
                        Authentication Method:
                      </Typography>
                    </Grid>

                    <Grid item xs={8} className='pr-0'>
                      <FormControl fullWidth>
                        <Select
                          placeholder='Select an Authentication Method'
                          variant='filled'
                          defaultValue={authOptions[0]}
                          input={<Input classes={{ underline: classes.underline }} />}
                          classes={selectClasses}
                        >
                          {
                            authOptions.map((auth, i) => (
                              <MenuItem key={`auth-${i}`} value={auth}>
                                {auth}
                              </MenuItem>
                            ))
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

              </Grid>
            </Paper>
          </Grid>

          <Grid container item direction='row' justify='flex-end' className='mt-4'>
            <Grid item>
              <Button
                variant='contained'
                className={classes.blueBtn}
                onClick={() => submitForm()}
              >
                Save
              </Button>
            </Grid>
          </Grid>

        </Grid>
      </Grid>
    </>
  )
}

export default OrganizationSettings
